import RequestService, { getQueryURL } from '../requestService';
import { Identitet } from '../../../models/identitet';
import { client } from '../../client';
import {
    AdmEnhetLight,
    EnkelIdentitet,
    PaginatedHistoryResult,
    PaginatedResult,
    RelasjonLight,
    Tilgangskode
} from '../../../models';
import { OppdatererPostnummer } from '../../../models/oppdatererPostnummer';
import { FilterQueries } from '../../../app/utils/filter';
import { PageParam } from '../../rtk-queries/queryApiCreator';
import { store } from '../../../app/store';
import { handleError } from '../../../features/layout/layoutSlice';
import { MessageRequiredAnswer } from '../../../models/messageRequiredAnswer';
import { TypeRelasjon } from '../../../models/Enum/TypeRelasjon';


export default class IdentitetService extends RequestService<Identitet, 'identitet'> {
    relasjonerHoved = async (identitetId: string, type: TypeRelasjon, visHistorikk?: boolean) =>
        client.get<PaginatedHistoryResult<RelasjonLight>>(getQueryURL(`${this.serviceName}/${encodeURIComponent(identitetId)}/relasjoner/hoved/${encodeURIComponent(type)}`, { visHistorikk }));
    relasjonerSekunder = async (identitetId: string, type: TypeRelasjon, visHistorikk?: boolean) => client.get<PaginatedHistoryResult<RelasjonLight>>(getQueryURL(`${this.serviceName}/${encodeURIComponent(identitetId)}/relasjoner/sekunder/${encodeURIComponent(type)}`, { visHistorikk }));
    
    opprettRelasjon = async (identitetId: string, value: RelasjonLight) =>
        client.post<RelasjonLight>(`${this.serviceName}/${encodeURIComponent(identitetId)}/relasjoner`, value);

    endreRelasjon = async (identitetId: string, relasjonId: number, value: RelasjonLight) => client.post<RelasjonLight>(`${this.serviceName}/${encodeURIComponent(identitetId)}/relasjoner/${encodeURIComponent(relasjonId)}`, value);
    slettRelasjon = async (identitetId: string, relasjoner: number[]) =>
        client.post(`${this.serviceName}/${encodeURIComponent(identitetId)}/relasjoner/slett`, relasjoner);
    avluttRelasjon = async (identitetId: string, relasjoner: number[], tilDato?: Date) => client.post(getQueryURL(`${this.serviceName}/${encodeURIComponent(identitetId)}/relasjoner/avslutt`, { tilDato }), relasjoner);
    stedfortrederErIBruk = async (identitetId: string, relasjonId: number) =>
        client.get<boolean>(getQueryURL(`${this.serviceName}/${encodeURIComponent(identitetId)}/relasjoner/stedfortreder_er_bruk/${encodeURIComponent(relasjonId)}`));
    enkelIdentitet = async (searchString: string, param: PageParam, filter?: FilterQueries,) =>
        client.post<PaginatedResult<EnkelIdentitet>>(getQueryURL(`${this.serviceName}/enkel_identitet/filter`, { q: searchString, ...param }), filter);
    kontaktPerson = async (searchString: string, disablePagination?: boolean) =>
        client.get<EnkelIdentitet[]>(getQueryURL(`${this.serviceName}/enkel_kontaktIdentitet`, { q: searchString, disablePagination }));

    virksomhet =
        async (id: EnkelIdentitet['id'], searchString: string) =>
            client.get<PaginatedResult<EnkelIdentitet>>(`${this.serviceName}/${encodeURIComponent(id)}/enkel_virksomhet?q=${encodeURIComponent(searchString)}`);

    brukere =
        async (searchString: string) =>
            client.get<EnkelIdentitet[]>(getQueryURL(`${this.serviceName}/enkel_brukerIdentitet`, { q: searchString }));

    enkelIdentiteterMedLoginer =
        async (searchString: string, kategoriId: string) =>
            client.get<PaginatedResult<EnkelIdentitet>>(getQueryURL(`${this.serviceName}/${encodeURIComponent(kategoriId)}/enkel_identiteter_med_loginer`, { q: searchString }));

    brukerefortekstmal =
        async (searchString: string, param?: PageParam,) =>
            client.get<PaginatedResult<EnkelIdentitet>>(getQueryURL(`${this.serviceName}/enkel_brukerIdentitet_for_tekstmal`, { q: searchString, ...param }));

    brukerefortekstmalParam =
        async (isLocalAdm: boolean, id: AdmEnhetLight['id'], searchString: string) =>
            client.get<PaginatedResult<EnkelIdentitet>>(`${this.serviceName}/${encodeURIComponent(isLocalAdm)}/${encodeURIComponent(id)}/enkel_brukerIdentitet_for_tekstmalParam?q=${encodeURIComponent(searchString)}`);


    finneMedPostnummer = async (oppdaterer: OppdatererPostnummer) => client.post<number>(`${this.serviceName}/finne_med_postnummer`, oppdaterer);
    postnummerPaaIdentiteter = async (oppdaterer: OppdatererPostnummer) => client.post<number>(`${this.serviceName}/postnummer_paa_identiteter`, oppdaterer);

    hentForhaandsvalgteTilgangskoder = async (fraIdentitet: EnkelIdentitet) => client.get<Tilgangskode[]>(`${this.serviceName}/${fraIdentitet.id}/relasjoner/forhaandsvalgte_tilgangskoder`);
    import = async (fileContent: Blob, filNavn: string) => {
        try {
            const buffer = await fileContent.arrayBuffer();
            const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/import`, { filNavn }), buffer);
            return { success: true, msg: res.message };
        } catch (err) {
            await store.dispatch(handleError(err as Error));
            return { success: false, msg: (err as Error).message };
        }
    };
}

